<template>
    <div id="app">
        <app-wrapper v-bind:branding="branding">
            <router-view v-bind:branding="branding"/>
        </app-wrapper>
    </div>
</template>

<script>
    import AppWrapper from '@/components/AppWrapper'
    export default {
        name: 'app',
        components: {
            AppWrapper
        },
        data () {
            return {
                /**
                 * This is shared accross AppWrapper and the router componenets so I've stored it here.
                 */
                branding: {
                    generic: null,
                    specific: null,
                    current: null
                }
            }
        }
    }
</script>

<style lang="scss">
    @import './assets/styles/custom.scss';
</style>
